(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore.js');
"use strict";


const {
  ReactIntersectionProvider
} = svs.components.lbUtils.intersectionObserver;
const {
  HighscoreList,
  HighscoreProvider,
  HighscoreChoiceButton,
  HighscoreContext
} = svs.components.marketplaceCompetition.routeResult.highscore;
const {
  HighscoreListType
} = svs.components.marketplaceCompetition.services.constants.highscoreConstants;
const {
  useSelector
} = ReactRedux;
const {
  ReactIcon
} = svs.ui;
const {
  Loader
} = svs.components.ReactLoader;
const {
  RadioGroup,
  ControlGroup
} = svs.ui.reactForm;
const {
  PersonalResults
} = svs.components.marketplaceCompetition.routeResult.personalResults;
const {
  HighscoreSearch
} = svs.components.marketplaceCompetition.routeResult.highscore;
const {
  selectCompetitionResultSearchTerm,
  selectCompetitionResultPending,
  selectCompetitionResult
} = svs.components.marketplaceCompetition.services.selectors.competitionResultSelectors;
const {
  userSession
} = svs.core;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useContext,
  useMemo
} = React;
const HighscoreBase = () => {
  const competitionId = useCompetitionId();
  const {
    typeDescription,
    type
  } = useContext(HighscoreContext);
  const searchterm = useSelector(state => selectCompetitionResultSearchTerm(state, type));
  const listIsPending = useSelector(state => selectCompetitionResultPending(state, competitionId, type));
  const list = useSelector(state => selectCompetitionResult(state, competitionId, type, 30));
  const searchDescription = "S\xF6k efter ".concat(typeDescription, "...");
  const individualLoading = listIsPending && type === HighscoreListType.Individual;
  const teamLoading = listIsPending && type === HighscoreListType.Team;
  const shouldRenderSearchbar = useMemo(() => searchterm !== '' || list.length > 0 && searchterm === '', [list.length, searchterm]);
  const isLoggedIn = userSession.hasRole(userSession.roles.PLAYER);
  return React.createElement("div", {
    className: "highscore-container competition-content"
  }, React.createElement("h2", {
    className: "highscore-title f-center f-medium"
  }, "Topplistan"), React.createElement("p", {
    className: "highscore-notice"
  }, React.createElement(ReactIcon, {
    icon: "information",
    size: "100"
  }), ' ', "Listan uppdateras efter varje avslutad omg\xE5ng"), React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(RadioGroup, {
    size: "200"
  }, React.createElement(HighscoreChoiceButton, {
    disabled: listIsPending,
    type: HighscoreListType.Individual
  }, !individualLoading && 'Individuell', individualLoading && React.createElement(Loader, {
    size: 200
  })), React.createElement(HighscoreChoiceButton, {
    disabled: listIsPending,
    type: HighscoreListType.Team
  }, !teamLoading && 'Lag', teamLoading && React.createElement(Loader, {
    size: 200
  })))), isLoggedIn && React.createElement(PersonalResults, {
    showIndividual: type === HighscoreListType.Individual,
    showTeams: type === HighscoreListType.Team
  }), shouldRenderSearchbar && React.createElement(HighscoreSearch, {
    competitionId: competitionId,
    description: searchDescription,
    searchterm: searchterm
  }), React.createElement(HighscoreList, null));
};
const Highscore = () => React.createElement(ReactIntersectionProvider, null, React.createElement(HighscoreProvider, null, React.createElement(HighscoreBase, null)));
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.Highscore', Highscore);

 })(window);